import ViewPlansPage from "components/viewPlans/ViewPlans.component"

const ViewPlans = () => {
  return (
    <ViewPlansPage />
  )
}

export default ViewPlans
